export const ISSUE_TRANSITION_POPUP_CHANGE = 'ISSUE_TRANSITION_POPUP_CHANGE';

export const issueTransitionPopupChange = (payload) => {
  return {
    type: ISSUE_TRANSITION_POPUP_CHANGE,
    payload,
  };
};
